import { Component, ViewChild } from "@angular/core";
import { CommonModule } from "@angular/common";
import { FormsModule } from "@angular/forms";
import { DataGridView, DataGridViewCollumn } from "../../../Componente/DataGridView";
import { LeitsetlleEdit } from "../../Controlls/EditViews/LeitsetlleEdit";
import { PopUpView } from "../../../Componente/PopUpView";
import { Kasse, Leitstelle } from "../../../Api/DcoApi/Admin/AdminClasses2";
import { KasseEdit } from "../../Controlls/EditViews/KasseEdit";


@Component({
  imports: [
    CommonModule,
    FormsModule,
    DataGridView,
    DataGridViewCollumn, KasseEdit, PopUpView
  ],
  selector: 'KassenList',
  templateUrl: './Kassen.html',
  standalone: true,
  styleUrl: './Kassen.css'
})
export class KassenList {
  @ViewChild('Grid') childComponent!: DataGridView<Kasse>;

  triggerReload() {
    // Call the child component's function safely
    this.childComponent.LoadData();
  }
}
